<ng-template [ngIf]="snapshotType === snapshotTypeEnum.BACKUP" [ngIfElse]="snapshotTemplate">
  <div class="table-header flex flex-row">
    <div
      class="flex flex-col justify-start items-start flex-[60%] max-w-[60%]"
      *ngIf="
        ((remoteDiagnosticsSnapshotsStore.getVddsWithContent$ | async)?.length !== 0 ||
          (remoteDiagnosticsSnapshotsStore.getVddsToCancel$ | async)?.length !== 0) &&
          remoteDiagnosticsSnapshotsStore.getDateOfTheValuesRead$ | async as valuesReadAtDate
      "
    >
      <div class="flex flex-row">
        <b
          >{{ '+REMOTE_DIAGNOSTICS_BACKUPS.GENERAL.CURRENT_VALUES_LABEL' | translate }} {{ ':' }}</b
        >
        <div class="selected-backup-date">
          {{ valuesReadAtDate | date: 'short' }}
        </div>
      </div>
    </div>
    <div
      *ngIf="
        remoteDiagnosticsSnapshotsStore.selectedSnapshot$ | async as snapshot;
        else noSnapshotSelected
      "
      class="flex flex-row justify-start items-start flex-[40%] max-w-[40%]"
    >
      <b>{{ '+REMOTE_DIAGNOSTICS_BACKUPS.LABEL.BACKUP' | translate }} {{ ':' }}</b>
      <div class="selected-backup-date">
        {{ snapshot.createdAt | date: 'short' }}
      </div>
      <ng-container *ngTemplateOutlet="connectionFailedTemplate"></ng-container>
    </div>
    <ng-template #noSnapshotSelected>
      {{ '+REMOTE_DIAGNOSTICS_BACKUPS.LABEL.SELECT_BACKUP_TO_COMPARE' | translate }}
    </ng-template>
  </div>
</ng-template>

<ng-template #snapshotTemplate>
  <div class="flex flex-col justify-start items-start">
    <div
      *ngIf="
        !fullWidthMode &&
          !(remoteDiagnosticsSnapshotsStore.getDateOfTheValuesRead$ | async) &&
          remoteDiagnosticsSnapshotsStore.selectedSnapshot$ | async
      "
      class="compare-btn-container flex flex-row"
    >
      <div class="compare-btn-and-loader flex flex-row justify-end items-end">
        <button
          *ngIf="!(remoteDiagnosticsSnapshotsStore.isAnyFromSnapshotVddListLoading$ | async)"
          gtm="onStart"
          gtmAction="read current values"
          gtmCategory="Snapshot"
          mat-button
          color="primary"
          [disabled]="
            !isActiveSessionAvailable ||
            (remoteDiagnosticsSnapshotsStore.isAnyFromSnapshotVddListLoading$ | async)
          "
          (click)="readCurrentValues()"
        >
          {{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.BTN.COMPARE_WITH_CURRENT_VALUES' | translate }}
        </button>
        <div class="snapshot-loader" *ngIf="!isConnectionFailed">
          <app-backup-loader></app-backup-loader>
        </div>
      </div>
    </div>
    <div *ngIf="!fullWidthMode" class="table-header flex flex-row">
      <ng-container *ngIf="remoteDiagnosticsSnapshotsStore.selectedSnapshot$ | async as snapshot">
        <div
          class="table-header-labels flex flex-row justify-start items-start flex-[60%] max-w-[60%]"
        >
          <b>{{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.LABEL.SELECTED_SNAPSHOT' | translate }} {{ ':' }}</b>
          <div class="selected-backup-date">
            {{ snapshot.createdAt | date: 'short' }}
          </div>
          <ng-container *ngTemplateOutlet="connectionFailedTemplate"></ng-container>
        </div>
        <div
          class="table-header-labels flex flex-col justify-start items-start flex-[40%] max-w-[40%]"
          *ngIf="
            !fullWidthMode && snapshot && remoteDiagnosticsSnapshotsStore.getDateOfTheValuesRead$
              | async as valuesReadAtDate
          "
        >
          <div class="flex flex-row">
            <b
              >{{ '+REMOTE_DIAGNOSTICS_BACKUPS.GENERAL.CURRENT_VALUES_LABEL' | translate }}
              {{ ':' }}</b
            >
            <div class="selected-backup-date">
              {{ valuesReadAtDate | date: 'short' }}
            </div>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template
  [ngIf]="snapshotType === snapshotTypeEnum.BACKUP"
  [ngIfElse]="snapshotTableItemTemplate"
>
  <div *ngFor="let vdd of vdds; trackBy: trackBy">
    <app-backup-vdd-table-item
      [fullWidthMode]="fullWidthMode"
      [vddName]="vdd.key"
      [logicalLink]="vdd.logicalLink"
    >
    </app-backup-vdd-table-item>
  </div>
</ng-template>

<ng-template #snapshotTableItemTemplate>
  <ng-container *ngFor="let vdd of vdds; trackBy: trackBy">
    <mat-expansion-panel
      *ngrxLet="isParameterInvalid(vdd) as isInvalid"
      [class.invalid-parameter]="isInvalid"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="vdd-name">
          {{ 'TI_' + vdd.key | translate }}
          <span *ngIf="isInvalid" class="error-label">
            {{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.CORRUPTED_PARAMETER_ERROR' | translate }}
          </span>
        </mat-panel-title>

        <button
          *ngIf="fullWidthMode"
          class="remove-vdd-btn"
          mat-icon-button
          (click)="selectVdd(vdd, $event)"
          gtm="onStart"
          gtmAction="remove selected vdd"
          gtmCategory="Snapshot"
        >
          <mat-icon>clear</mat-icon>
        </button>
      </mat-expansion-panel-header>
      <app-backup-vdd-table-item
        [fullWidthMode]="fullWidthMode"
        [vddName]="vdd.key"
        [logicalLink]="vdd.logicalLink"
      >
      </app-backup-vdd-table-item>
    </mat-expansion-panel>
  </ng-container>
</ng-template>

<ng-template #connectionFailedTemplate>
  <div class="connection-failed" *ngIf="isConnectionFailed">
    {{ '+REMOTE_DIAGNOSTICS_BACKUPS.CONNECTION_FAILED_MESSAGE' | translate }}
  </div>
</ng-template>
